var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 0;
var op = 120.0000048877;
var w = 469;
var h = 469;
var nm = "pencilruler  nofade";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "ruler",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    235,
                    235,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                -127.026,
                                0
                            ]
                        ],
                        o: [
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                -127.026,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        v: [
                            [
                                0.5,
                                230.5
                            ],
                            [
                                230.5,
                                0.5
                            ],
                            [
                                0.5,
                                -229.5
                            ],
                            [
                                -229.5,
                                0.5
                            ],
                            [
                                0.5,
                                230.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ty: "gr",
                        it: [
                            {
                                ind: 1,
                                ty: "sh",
                                ix: 2,
                                ks: {
                                    a: 0,
                                    k: {
                                        i: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        o: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        v: [
                                            [
                                                70.376,
                                                36.27
                                            ],
                                            [
                                                57.801,
                                                48.845
                                            ]
                                        ],
                                        c: false
                                    },
                                    ix: 2
                                },
                                nm: "Path 14",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ind: 2,
                                ty: "sh",
                                ix: 3,
                                ks: {
                                    a: 0,
                                    k: {
                                        i: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        o: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        v: [
                                            [
                                                54.717,
                                                19.01
                                            ],
                                            [
                                                47.629,
                                                26.098
                                            ]
                                        ],
                                        c: false
                                    },
                                    ix: 2
                                },
                                nm: "Path 13",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ind: 3,
                                ty: "sh",
                                ix: 4,
                                ks: {
                                    a: 0,
                                    k: {
                                        i: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        o: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        v: [
                                            [
                                                37.457,
                                                3.351
                                            ],
                                            [
                                                24.882,
                                                15.926
                                            ]
                                        ],
                                        c: false
                                    },
                                    ix: 2
                                },
                                nm: "Path 6",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ind: 4,
                                ty: "sh",
                                ix: 5,
                                ks: {
                                    a: 0,
                                    k: {
                                        i: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        o: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        v: [
                                            [
                                                21.798,
                                                -13.909
                                            ],
                                            [
                                                14.71,
                                                -6.821
                                            ]
                                        ],
                                        c: false
                                    },
                                    ix: 2
                                },
                                nm: "Path 12",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ind: 5,
                                ty: "sh",
                                ix: 6,
                                ks: {
                                    a: 0,
                                    k: {
                                        i: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        o: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        v: [
                                            [
                                                4.538,
                                                -29.567
                                            ],
                                            [
                                                -8.037,
                                                -16.993
                                            ]
                                        ],
                                        c: false
                                    },
                                    ix: 2
                                },
                                nm: "Path 8",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ind: 6,
                                ty: "sh",
                                ix: 7,
                                ks: {
                                    a: 0,
                                    k: {
                                        i: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        o: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        v: [
                                            [
                                                -11.121,
                                                -46.828
                                            ],
                                            [
                                                -18.209,
                                                -39.74
                                            ]
                                        ],
                                        c: false
                                    },
                                    ix: 2
                                },
                                nm: "Path 7",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ind: 7,
                                ty: "sh",
                                ix: 8,
                                ks: {
                                    a: 0,
                                    k: {
                                        i: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        o: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        v: [
                                            [
                                                -28.381,
                                                -62.486
                                            ],
                                            [
                                                -40.956,
                                                -49.912
                                            ]
                                        ],
                                        c: false
                                    },
                                    ix: 2
                                },
                                nm: "Path 11",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ind: 8,
                                ty: "sh",
                                ix: 9,
                                ks: {
                                    a: 0,
                                    k: {
                                        i: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        o: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        v: [
                                            [
                                                -44.039,
                                                -79.747
                                            ],
                                            [
                                                -51.128,
                                                -72.658
                                            ]
                                        ],
                                        c: false
                                    },
                                    ix: 2
                                },
                                nm: "Path 10",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ty: "st",
                                c: {
                                    a: 0,
                                    k: [
                                        0.525490224361,
                                        0.450980395079,
                                        0.705882370472,
                                        1
                                    ],
                                    ix: 3,
                                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 4
                                },
                                w: {
                                    a: 0,
                                    k: 19.167,
                                    ix: 5
                                },
                                lc: 2,
                                lj: 2,
                                bm: 0,
                                nm: "Stroke 1",
                                mn: "ADBE Vector Graphic - Stroke",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        5,
                                        3
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "Group 1",
                        np: 10,
                        cix: 2,
                        bm: 0,
                        ix: 1,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "gr",
                        it: [
                            {
                                ind: 0,
                                ty: "sh",
                                ix: 1,
                                ks: {
                                    a: 0,
                                    k: {
                                        i: [
                                            [
                                                -3.007,
                                                -3.007
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.007,
                                                -3.007
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.007,
                                                3.007
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.007,
                                                3.007
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        o: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.007,
                                                3.007
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.007,
                                                3.007
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.007,
                                                -3.007
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.007,
                                                -3.007
                                            ]
                                        ],
                                        v: [
                                            [
                                                -46.677,
                                                -90.569
                                            ],
                                            [
                                                90.569,
                                                46.677
                                            ],
                                            [
                                                90.569,
                                                57.566
                                            ],
                                            [
                                                57.566,
                                                90.569
                                            ],
                                            [
                                                46.677,
                                                90.569
                                            ],
                                            [
                                                -90.569,
                                                -46.677
                                            ],
                                            [
                                                -90.569,
                                                -57.566
                                            ],
                                            [
                                                -57.566,
                                                -90.569
                                            ]
                                        ],
                                        c: true
                                    },
                                    ix: 2
                                },
                                nm: "Path 16",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ty: "st",
                                c: {
                                    a: 0,
                                    k: [
                                        0.525490224361,
                                        0.450980395079,
                                        0.705882370472,
                                        1
                                    ],
                                    ix: 3,
                                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 4
                                },
                                w: {
                                    a: 0,
                                    k: 19.167,
                                    ix: 5
                                },
                                lc: 2,
                                lj: 2,
                                bm: 0,
                                nm: "Stroke 2",
                                mn: "ADBE Vector Graphic - Stroke",
                                hd: false
                            },
                            {
                                ty: "fl",
                                c: {
                                    a: 0,
                                    k: [
                                        0.972549080849,
                                        0.949019670486,
                                        0.972549080849,
                                        1
                                    ],
                                    ix: 4,
                                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 5
                                },
                                r: 1,
                                bm: 0,
                                nm: "Fill 1",
                                mn: "ADBE Vector Graphic - Fill",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "Group 2",
                        np: 3,
                        cix: 2,
                        bm: 0,
                        ix: 2,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 14,
                                    s: [
                                        -350,
                                        0
                                    ],
                                    to: [
                                        58.333,
                                        0
                                    ],
                                    ti: [
                                        -58.333,
                                        0
                                    ]
                                },
                                {
                                    t: 25.0000010182709,
                                    s: [
                                        0,
                                        0
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.667
                                        ],
                                        y: [
                                            1
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.333
                                        ],
                                        y: [
                                            0
                                        ]
                                    },
                                    t: 14,
                                    s: [
                                        -90
                                    ]
                                },
                                {
                                    t: 25.0000010182709,
                                    s: [
                                        0
                                    ],
                                    h: 1
                                }
                            ],
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "pencil",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233.041,
                    231.623,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    498.041,
                    496.623,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                -127.026,
                                0
                            ]
                        ],
                        o: [
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                -127.026,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        v: [
                            [
                                500.5,
                                730.5
                            ],
                            [
                                730.5,
                                500.5
                            ],
                            [
                                500.5,
                                270.5
                            ],
                            [
                                270.5,
                                500.5
                            ],
                            [
                                500.5,
                                730.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ty: "gr",
                        it: [
                            {
                                ind: 0,
                                ty: "sh",
                                ix: 1,
                                ks: {
                                    a: 0,
                                    k: {
                                        i: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        o: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        v: [
                                            [
                                                -15.997,
                                                -15.997
                                            ],
                                            [
                                                15.997,
                                                15.997
                                            ]
                                        ],
                                        c: false
                                    },
                                    ix: 2
                                },
                                nm: "Path 1",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ty: "st",
                                c: {
                                    a: 0,
                                    k: [
                                        0.525490224361,
                                        0.450980395079,
                                        0.705882370472,
                                        1
                                    ],
                                    ix: 3,
                                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 4
                                },
                                w: {
                                    a: 0,
                                    k: 19.167,
                                    ix: 5
                                },
                                lc: 2,
                                lj: 2,
                                bm: 0,
                                nm: "Stroke 1",
                                mn: "ADBE Vector Graphic - Stroke",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        -60.352,
                                        60.6
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "Path-72",
                        np: 2,
                        cix: 2,
                        bm: 0,
                        ix: 1,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "gr",
                        it: [
                            {
                                ind: 0,
                                ty: "sh",
                                ix: 1,
                                ks: {
                                    a: 0,
                                    k: {
                                        i: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        o: [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        v: [
                                            [
                                                -21.946,
                                                -21.946
                                            ],
                                            [
                                                6.917,
                                                6.917
                                            ],
                                            [
                                                21.946,
                                                21.946
                                            ]
                                        ],
                                        c: false
                                    },
                                    ix: 2
                                },
                                nm: "Path 1",
                                mn: "ADBE Vector Shape - Group",
                                hd: false
                            },
                            {
                                ty: "st",
                                c: {
                                    a: 0,
                                    k: [
                                        0.525490224361,
                                        0.450980395079,
                                        0.705882370472,
                                        1
                                    ],
                                    ix: 3,
                                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 4
                                },
                                w: {
                                    a: 0,
                                    k: 19.167,
                                    ix: 5
                                },
                                lc: 2,
                                lj: 2,
                                bm: 0,
                                nm: "Stroke 1",
                                mn: "ADBE Vector Graphic - Stroke",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        55.113,
                                        -54.865
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "Path-73",
                        np: 2,
                        cix: 2,
                        bm: 0,
                        ix: 2,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ind: 2,
                        ty: "sh",
                        ix: 3,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -3.007,
                                        -3.007
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        3.007,
                                        -3.007
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        1.584,
                                        -0.264
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0.698,
                                        4.195
                                    ],
                                    [
                                        -0.181,
                                        0.912
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -1.077,
                                        1.077
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        3.007,
                                        -3.007
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        3.007,
                                        3.007
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -1.135,
                                        1.135
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -4.195,
                                        0.698
                                    ],
                                    [
                                        -0.153,
                                        -0.917
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0.297,
                                        -1.494
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        47.747,
                                        -91.055
                                    ],
                                    [
                                        58.636,
                                        -91.055
                                    ],
                                    [
                                        91.639,
                                        -58.052
                                    ],
                                    [
                                        91.639,
                                        -47.163
                                    ],
                                    [
                                        -39.756,
                                        84.231
                                    ],
                                    [
                                        -43.936,
                                        86.382
                                    ],
                                    [
                                        -84.931,
                                        93.205
                                    ],
                                    [
                                        -93.79,
                                        86.873
                                    ],
                                    [
                                        -93.746,
                                        84.108
                                    ],
                                    [
                                        -85.848,
                                        44.376
                                    ],
                                    [
                                        -83.741,
                                        40.433
                                    ],
                                    [
                                        -83.741,
                                        40.433
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.525490224361,
                                0.450980395079,
                                0.705882370472,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 14,
                                    s: [
                                        858.041,
                                        496.623
                                    ],
                                    to: [
                                        -60,
                                        0
                                    ],
                                    ti: [
                                        60,
                                        0
                                    ]
                                },
                                {
                                    t: 25.0000010182709,
                                    s: [
                                        498.041,
                                        496.623
                                    ],
                                    h: 1
                                }
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.667
                                        ],
                                        y: [
                                            1
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.333
                                        ],
                                        y: [
                                            0
                                        ]
                                    },
                                    t: 14,
                                    s: [
                                        90
                                    ]
                                },
                                {
                                    t: 25.0000010182709,
                                    s: [
                                        0
                                    ],
                                    h: 1
                                }
                            ],
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 4,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "circle",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 14.0000005702317,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    235,
                    235,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        -127.026,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        -127.026,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        230
                                    ],
                                    [
                                        230,
                                        0
                                    ],
                                    [
                                        0,
                                        -230
                                    ],
                                    [
                                        -230,
                                        0
                                    ],
                                    [
                                        0,
                                        230
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.972549021244,
                                0.949019610882,
                                0.972549021244,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var PencilRuler = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, PencilRuler as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=PencilRuler.json.es.js.map
